
import axios from 'axios';
import * as turf from "@turf/turf";
import { useState, useRef, useEffect, useCallback } from "react"
import Select from 'react-select'
import Table from 'react-bootstrap/Table';
import { formatDate } from '../CustomDateTools';
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    Popup,

    Source,
    Layer,
    useMap
} from 'react-map-gl/maplibre';




const GoldFinderGeoserver = axios.create({
    baseURL: process.env.REACT_APP_GOLD_FINDER_GEOSERVER
})

// gswa_load_date arrives from WFS as an ISO string (or null/undefined for
// undated samples). Render it as DD/MM/YYYY, or a dash when absent/invalid.
function formatLoadDate(value) {
    if (!value) return "—";
    const d = new Date(value);
    return isNaN(d.getTime()) ? "—" : formatDate(d);
}



/*
    ppblt: 9999,
    ppbmt: 30,
    maxresults: 500,
    type: sampleTypeDataPreSelected,
    nullValues: false,
*/

export function queryAssayAnumberWFS(anumber) {
    const ecqlFilter = ` anumber = ${anumber}`

    return GoldFinderGeoserver.get("/ne/ows?", {
        params: {
            service: 'WFS',
            version: '1.1.0',
            request: 'GetFeature',
            typeNames: 'ne:wa_au_soil_assays',
            maxFeatures: 99999,

            outputFormat: 'application/json',
            srs: 'EPSG:4326',
            cql_filter: ecqlFilter
        }
    })

}

export function queryAssaySampleIdWFS(sampleId) {
    // Handle both numeric ID and string company sample ID
    const isNumeric = /^\d+$/.test(sampleId);
    let ecqlFilter;
    
    if (isNumeric) {
        // If input is numeric, search multiple possible ID fields
        // Try id, surfacesampleid, and companysampleid fields for numeric values
        ecqlFilter = `id = ${sampleId} OR surfacesampleid = ${sampleId} OR companysampleid = '${sampleId}' OR companysampleid LIKE '%${sampleId}%'`;
    } else {
        // If input contains non-numeric characters, only search companysampleid
        ecqlFilter = `companysampleid LIKE '%${sampleId}%'`;
    }

    console.log('Sample ID WFS Query Filter:', ecqlFilter); // Debug logging

    return GoldFinderGeoserver.get("/ne/ows?", {
        params: {
            service: 'WFS',
            version: '1.1.0',
            request: 'GetFeature',
            typeNames: 'ne:wa_au_soil_assays',
            maxFeatures: 99999,
            outputFormat: 'application/json',
            srs: 'EPSG:4326',
            cql_filter: ecqlFilter
        }
    })
}

export function queryAssayWFS(bboxString, setStateGeoJSON, assayFilters) {

    if (assayFilters.anumber !== 0) { return }

    const assayTypeArr = assayFilters.type.map(e => e.value)

    const ecqlFilter = `
        BBOX(geom,${bboxString})
        and 
        (
        au_ppb BETWEEN ${assayFilters.ppbmt} AND ${assayFilters.ppblt}
        ${assayFilters.nullValues ? 'OR au_ppb is null' : ''}
        )
        and
        surfacesampletype in ('${assayTypeArr.join(`','`)}')
        
        `


    GoldFinderGeoserver.get("/ne/ows?", {
        params: {
            service: 'WFS',
            version: '1.1.0',
            request: 'GetFeature',
            typeNames: 'ne:wa_au_soil_assays',
            maxFeatures: 99999,

            outputFormat: 'application/json',
            srs: 'EPSG:4326',
            //bbox: bboxString,
            //filter: filterQuery
            cql_filter: ecqlFilter
        }
    }).then((e) => {
        // filter tenemements

        setStateGeoJSON(e.data);
    });
}


export function createSingleAssayPopupTable(assay, lngLat, setClosed, setModalShow, setReportedAssay) {
    return <Popup latitude={lngLat.lat} longitude={lngLat.lng}
        anchor="bottom"
        onClose={() => setClosed(false)}>
            <Table striped bordered  className="mb-1" >
                <tbody>
                    <tr>
                        <td>ID:</td>
                        <td>
                            {assay.properties.id}
                            {(assay.properties.reported_sample_id !== undefined ?
                                <FontAwesomeIcon title="This Sample Has been reported as inaccurate or incorrect." style={{ marginLeft: 3 }} icon={faCircleExclamation} />
                                : "")}
                        </td>
                    </tr>
                    <tr>
                        <td>Au PPB:</td>
                        <td>{assay.properties.au_ppb}</td>
                    </tr>
                    <tr>
                        <td>Sample Type:</td>
                        <td>{assay.properties.surfacesampletype}</td>
                    </tr>
                    <tr>
                        <td>A Number:</td>
                        <td>
                            <a target="_blank" href={`https://wamex.dmp.wa.gov.au/Wamex/Search/ReportDetails?ANumber=${assay.properties.anumber}`}>
                                {assay.properties.anumber}
                            </a>
                            {(assay.properties.reported_sample_anumber_id !== undefined ?
                                <FontAwesomeIcon title="The samples related to this A Number have been reported as inaccurate or incorrect." style={{ marginLeft: 3 }} icon={faCircleExclamation} />
                                : "")}
                        </td>
                    </tr>
                    <tr>
                        <td>Company Sample ID:</td>
                        <td>{assay.properties.companysampleid}</td>
                    </tr>
                    <tr>
                        <td>DMPE Load Date:</td>
                        <td>{formatLoadDate(assay.properties.gswa_load_date)}</td>
                    </tr>
                </tbody>
            </Table>
            {
                (
                    assay.properties.reported_sample_anumber_id === undefined && assay.properties.reported_sample_id === undefined ?
                        <button className="btn btn-secondary btn-sm" style={{fontSize:10}} onClick={() => { setModalShow(true); setReportedAssay(assay.properties) }}>Report Sample</button>
                        : ""
                )
            }
    </Popup >
}

function AssayLayers({ assayMarkerColourSettings, overlayVisibility }) {

    const orderedAssayMarkerArray = assayMarkerColourSettings.toSorted((a, b) => a.moreThan - b.moreThan);

    const rows = [];

    // push  white under
    for (let i = 0; i < orderedAssayMarkerArray.length; i++) {
        const next = i + 1;

        const layerConfig = {
            id: orderedAssayMarkerArray[i].id,
            'source': 'soilsamples',
            type: 'circle',
            // type:'symbol',
            minzoom: 10.6,
            paint: { 'circle-color': orderedAssayMarkerArray[i].color, 'circle-radius': 6 },
            filter: ['all',
                ['>=', 'au_ppb', orderedAssayMarkerArray[i].moreThan],
                ['<', 'au_ppb', i !== orderedAssayMarkerArray.length - 1 ? orderedAssayMarkerArray[next].moreThan : 9999],
                //['!=', 'au_ppb', null]
            ],
            layout: { visibility: `${overlayVisibility.soils ? "visible" : "none"}` }
            //layout:{'icon-image':'test-img'}
        }

        rows.push(<Layer {...layerConfig} />)
    }
    return rows;
}


export function AssayOverlayMapLibre({ overlayVisibility, assayMarkerColourSettings, assayGeoJson, setAssayGeojson, assayFilters }) {
    const emptyGeoJson = {
        "type": "FeatureCollection",
        "name": "assay_samples",
        "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:EPSG::4326" } },
        "features": []
    };

    const { goldfindermap } = useMap(); // `mymap` is the id in <Map id="mymap" />

    useEffect(() => {

        if (!goldfindermap) return undefined;

        if (goldfindermap.getZoom() > 10.6) {
            const bounds = goldfindermap.getBounds();
            var wfsbbox = [bounds.getSouthWest().lng, bounds.getSouthWest().lat, bounds.getNorthEast().lng, bounds.getNorthEast().lat].join();
            queryAssayWFS(wfsbbox, setAssayGeojson, assayFilters)
        }

    }, [assayFilters])


    const backgroundConfig = {
        id: 'assay-background-config',
        'source': 'soilsamples',
        minzoom: 10.6,
        type: 'circle',
        paint: { 'circle-color': '#f9f9f9', 'circle-radius': 7 },
        layout: { visibility: `${overlayVisibility.soils ? "visible" : "none"}` }
    }

    return <Source id="soilsamples" type="geojson" data={assayGeoJson}>
        <Layer {...backgroundConfig} />
        <AssayLayers overlayVisibility={overlayVisibility} assayMarkerColourSettings={assayMarkerColourSettings} />
    </Source>
}